<template>
    <CheckBox
        :is-disabled="isDisabled"
        true-text="payed"
        false-text="onCredit"
        :model-form="modelForm"
        :model-name="modelName"
        :do-action="doAction"
        :column-size="columnSize"
        :md-size="mdSize"
    />
</template>

<script>
import CheckBox from "./CheckBoxRow";

export default {
    name: "CreditOrPayed",
    components: {CheckBox},
    props: {
        modelForm: {
            type: Object,
            required: true,
        },

        // optional
        modelName: {
            type: String,
            default: "isPayed",
        },
        doAction: {
            type: Function,
            default: function () {
            },
        },
        columnSize: {
            type: String,
            default: '2'
        },
        mdSize: {
            type: String,
            default: '2'
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
}
</script>
